"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CARBON_SIDENAV_ITEMS = void 0;
var CARBON_SIDENAV_ITEMS = ['SideNavFooter', 'SideNavHeader', 'SideNavItems', 'SideNavMenu'];
exports.CARBON_SIDENAV_ITEMS = CARBON_SIDENAV_ITEMS;